import { IDropdownOption } from '@fluentui/react';

export type EScorerLatencyEntry = {
  date: string;
  modelName: string;
  scoreMode: 'batch' | 'real_time';
  dataPointsCount: number;
  avgLatency: number;
};

export enum EScorerLatencyColumns {
  Date = 'date',
  ModelName = 'modelName',
  ScoreMode = 'scoreMode',
  DataPointsCount = 'dataPointsCount',
  AvgLatency = 'avgLatency',
}

export type EScorerErrorEntry = {
  date: string;
  modelName: string;
  scoreMode: 'batch' | 'real_time';
  totalErrors: number;
  lastErrorMsg: string;
};

export enum EScorerErrorColumns {
  Date = 'date',
  ModelName = 'modelName',
  ScoreMode = 'scoreMode',
  TotalErrors = 'totalErrors',
  LastErrorMsg = 'lastErrorMsg',
}

export const eScorerScoreModeOptions: IDropdownOption[] = [
  {
    key: 'BATCH',
    text: 'Batch',
  },
  {
    key: 'REAL_TIME',
    text: 'Real Time',
  },
];

export const eScorerComponentsLabelsMap: Record<string, string> = {
  totalErrors: 'Total Errors',
  datapoints: 'Datapoints',
};

export const eScorerComponentsColorMap: Record<string, string> = {
  totalErrors: '#EF9A9A',
  datapoints: '#C5E1A5',
};
